module.exports = __webpack_public_path__ + "img/local-4.cd2bc4c1.jpg";